// eslint-disable-next-line no-unused-vars
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { ROUTE } from 'src/constants';
import {
  adminCashExchangesMetaSelector,
  adminCashExchangesSelector,
  getAdminCashExchanges,
} from 'src/store/adminCashExchange';

export const useBuild = () => {
  const { t } = useTranslation('adminBuilder');

  const dispatch = useDispatch();

  const cashExchanges = useSelector(adminCashExchangesSelector);
  const cashExchangesMeta = useSelector(adminCashExchangesMetaSelector);

  const [searchParams, setSearchParams] = useSearchParams();

  const [filtersData, setFiltersData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const convertedParams = Object.fromEntries(searchParams.entries());

    setFiltersData(convertedParams);
    setCurrentPage(Number(convertedParams?.page) || 1);

    dispatch(getAdminCashExchanges(convertedParams));
  }, [dispatch, searchParams]);

  const onSubmitFilters = useCallback(
    (filters) => {
      setCurrentPage(1);

      dispatch(getAdminCashExchanges({ ...filters }));
    },
    [dispatch],
  );

  const onChangePage = useCallback(
    (page) => {
      setCurrentPage(page);

      const convertedParams = Object.fromEntries(searchParams.entries());

      const data = { ...convertedParams, ...filtersData, page: page?.toString() };

      for (const key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }

      setSearchParams(data);
      dispatch(getAdminCashExchanges(data));
    },
    [searchParams, filtersData, setSearchParams, dispatch],
  );

  const build = {
    title: t('cashExchangesForm:main'),
    styled_by_status: true,
    table_data: cashExchanges,
    table_meta: { ...cashExchangesMeta, current_page: currentPage, on_change_page: onChangePage },
    filters_data: filtersData,
    set_filters_data: setFiltersData,
    on_submit_filters: onSubmitFilters,
    main_route: ROUTE.ADMIN.CASH_EXCHANGE.MAIN,
    table_columns: [
      {
        id: 'id',
        key: 'id',
        label: t('label:id'),
      },
      {
        id: 'status',
        key: 'status',
        label: t('label:status'),
        value: (item) => <>{item?.active ? 'Активно' : 'Не активно'}</>,
      },
      {
        id: 'created_at',
        key: 'created_at',
        label: t('label:created'),
        value: (item) => <>{moment(item?.created_at).format('DD.MM.YYYY, HH:mm')}</>,
      },
      {
        id: 'country',
        key: 'country',
        label: t('label:country'),
      },
      {
        id: 'city',
        key: 'city',
        label: t('label:city'),
      },
      {
        id: 'address',
        key: 'address',
        label: t('label:address'),
      },
    ],
    filters: [
      // {
      //   key: 'id',
      //   label: t('searchById'),
      //   type: 'input',
      // },
      // {
      //   key: 'login',
      //   label: t('searchByLogin'),
      //   type: 'input',
      // },
      // {
      //   key: 'email',
      //   label: t('searchByEmail'),
      //   type: 'input',
      // },
      // {
      //   key: 'order',
      //   label: t('successOrders'),
      //   type: 'select',
      //   options: [
      //     {
      //       label: t('yes'),
      //       value: '1',
      //     },
      //     {
      //       label: t('no'),
      //       value: '0',
      //     },
      //   ],
      // },
      // {
      //   key: 'datePicker',
      //   label: t('createdDate'),
      //   type: 'datepicker',
      // },
    ],
  };

  return { build };
};
